import App from "@/views/App.vue";

export default [
  {
    path: "/meu-perfil",
    name: "profile",
    component: App,
    redirect: { name: "profileHome" },
    children: [
      {
        path: "",
        name: "profileHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewProfile.vue"),
        meta: {
          displayName: "Meu perfil - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/passo-perfil",
        name: "profileStep",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/StepProfile.vue"),
        meta: {
          displayName: "Meu perfil - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/meu-perfil/editar-informacoes",
        name: "profileEditInfo",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditProfile.vue"),
        meta: {
          displayName: "Editar Informações - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/perfil/:id",
        name: "profileCLevel",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewProfileCLevel.vue"
          ),
        meta: {
          displayName: "Perfil - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/perfil-marketing/:id",
        name: "profileMarketing",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewProfileMarketing.vue"
          ),
        meta: {
          displayName: "Perfil Empresa - Exclusive Lounge",
          requiresAuth: true,
        },
      },
      {
        path: "/formulario-case",
        name: "profileCase",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/SubmitCase.vue"),
        meta: {
          displayName: "Formulário case - Exclusive Lounge",
          requiresAuth: true,
        },
      },
    ],
  },
];
